import { useState, useEffect, useCallback } from 'react'

export const onMount = (handleMount, ...dependencies) => {
  useEffect(() => handleMount(...dependencies), dependencies)
}
